import {PathwaysTriggerOn} from '@ispm/test/store/prefetch-data/prefetch-data.actions';


export const prefetchDataModel = {

  pathways: [PathwaysTriggerOn]

};
